import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import http from "../../utils/http";

const initialState = {
  isLoading: false,
  products: [],
};

export const getSidekickProducts = createAsyncThunk(
  "application/getSidekickProducts",
  async (payload, thunkAPI) => {
    try {
      const response = await http.get(
        `${
          process.env.REACT_APP_API_SIDEKICK_BASE_URL
        }/get-product-purchase-stats?limit=${20}&page=${payload?.currentPage}&sortOrder=${payload?.sortOrder}&sortBy=${payload?.sortBy}&searchVal=${payload?.debouncedSearchTerm}`
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const sidekickProductsSlice = createSlice({
  name: "sidekick-products",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSidekickProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSidekickProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.products = action.payload;
      })
      .addCase(getSidekickProducts.rejected, (state) => {
        state.isLoading = false;
        state.products = [];
      })
  },
});

export default sidekickProductsSlice.reducer;
